<script>
import 'prismjs';
import 'prismjs/components/prism-json';
import Prism from 'vue-prism-component';

export default {
    name: 'data-viewer-fullscreen',
    props: ['code', 'title'],
    components: { prism: Prism },
    data() {
        return {
            loading: true,
        };
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            this.loading = false;
        })
    },
};
</script>

<template>
    <div class="data-viewer-fullscreen" >
        <a-spin :spinning="loading">
            <header class="head">
                <h3>{{ title }}</h3>
                <copy :text="code" class="icon-copy"/>
                <a class="close" href="#" @click="$emit('close')"></a>
            </header>
            <prism language="json" class="json-content">{{ code }}</prism>
        </a-spin>
    </div>
</template>
<style lang="scss">
    .data-viewer-fullscreen {
        .head {
            display: flex;
            align-items: center;
            .icon-copy {
                display: inline-block;
            }
        }
        .json-content {
            max-height: calc(100vh  - 172px);
        }
    }
</style>
